import { connect } from 'react-redux';

import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { RecentsSpace, RecentsSpaceOwnProps, RecentsSpaceStateProps } from './RecentsSpace';

const mapStateToProps: MapStateToProps<RecentsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state)
});

export const ConnectedRecentsSpace: React.ComponentClass<RecentsSpaceOwnProps>
  = connect(mapStateToProps, {})(RecentsSpace);
